import { AxiosResponse } from "axios";
import catalog from "@granular/fabric-catalog";

import { getAuthToken, granularAxiosInstance } from "./granularAxios";
import { EnrollmentsNetworkResponse } from "../models/enrollments";
import {
  FieldEnrollmentsNetworkResponse,
  FieldEnrollmentResponse,
  CreateFieldEnrollmentRequest,
} from "../models/enrollments";

const ISOTimestamp = (): string => new Date().toISOString();

type PayloadForGetEnrollments = {
  userId: string;
  operationId: string;
};

// OLD SERVICE, will be deprecated
const getEnrollments = (
  payload: PayloadForGetEnrollments,
): Promise<AxiosResponse<EnrollmentsNetworkResponse>> => {
  return granularAxiosInstance.request<
    never,
    AxiosResponse<EnrollmentsNetworkResponse>
  >({
    method: "GET",
    url: `/api/enrollments-svc/v3/enrollments?request_date=${ISOTimestamp()}&operation_id=${
      payload.operationId
    }&values=total_area,start_date,end_date,total_price,source,currency_code`,
    headers: {
      "x-granular-id": payload.userId,
      "x-operation": payload.operationId,
    },
  });
};

type PayloadForGetFieldEnrollments = {
  userId: string;
  operationId: string;
};

const getFieldEnrollments = async (
  payload: PayloadForGetFieldEnrollments,
  catalogFlag?: boolean,
): Promise<AxiosResponse<FieldEnrollmentsNetworkResponse>> => {
  let response;
  if (catalogFlag) {
    const catalogConfig = {
      // IMPORTANT: We are not passing the authToken as part of the queryKey
      // because we don't want to invalidate our data on auth token change.
      // The auth token can and will change throughout the lifetime of the app,
      // but that should not invalidate our data.
      getAuthToken,
      getOperationId: () => payload.operationId,
    };
    response = await catalog.enrollments.getFieldEnrollments(catalogConfig);
  } else {
    response = await granularAxiosInstance.get(
      "/api/enrollments-svc-lambda/enrollment/field",
      {
        headers: {
          "x-granular-id": payload.userId,
          "x-operation": payload.operationId,
        },
      },
    );
  }
  return response;
};

const enrollFields = async (
  operationId: string,
  createFieldEnrollmentRequest: CreateFieldEnrollmentRequest,
  catalogFlag?: boolean,
): Promise<FieldEnrollmentResponse[]> => {
  let response;
  if (catalogFlag) {
    const catalogConfig = {
      // IMPORTANT: We are not passing the authToken as part of the queryKey
      // because we don't want to invalidate our data on auth token change.
      // The auth token can and will change throughout the lifetime of the app,
      // but that should not invalidate our data.
      getAuthToken,
      getOperationId: () => operationId,
    };
    response = await catalog.enrollments.enrollFields(
      createFieldEnrollmentRequest,
      catalogConfig,
    );
  } else {
    response = await granularAxiosInstance.post<
      CreateFieldEnrollmentRequest,
      AxiosResponse<FieldEnrollmentResponse[]>
    >(
      "/api/enrollments-svc-lambda/enrollment/field",
      createFieldEnrollmentRequest,
    );
  }
  return response.data;
};

export default {
  getEnrollments,
  getFieldEnrollments,
  enrollFields,
};
